'use client';

import { useRef } from 'react';

type ReviewItem = {
  id: string;
  name: string;
  date: string;
  rating: number;
  text: string;
  platform: string;
};

export default function ReviewsCarousel({ reviews }: { reviews: ReviewItem[] }) {
  const trackRef = useRef<HTMLDivElement | null>(null);

  const scrollBy = (delta: number) => {
    if (!trackRef.current) return;
    trackRef.current.scrollBy({ left: delta, behavior: 'smooth' });
  };

  return (
    <div className="relative max-w-full overflow-hidden">
      <button
        type="button"
        onClick={() => scrollBy(-320)}
        className="absolute left-3 top-4 hidden h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-foreground shadow-md md:inline-flex"
        aria-label="Previous reviews"
      >
        ‹
      </button>
      <button
        type="button"
        onClick={() => scrollBy(320)}
        className="absolute right-3 top-4 hidden h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-foreground shadow-md md:inline-flex"
        aria-label="Next reviews"
      >
        ›
      </button>
      <div
        ref={trackRef}
        className="flex w-full gap-4 overflow-x-auto scroll-smooth pb-2 snap-x snap-mandatory overscroll-x-contain"
      >
        {reviews.map((review) => (
          <div
            key={review.id}
            className="min-w-[260px] max-w-[280px] flex-none snap-start rounded-2xl border border-border bg-ghost/30 p-4 space-y-3"
          >
            <div className="flex items-center justify-between">
              <div className="text-sm font-semibold text-foreground">{review.name}</div>
              <div className="text-xs text-muted-foreground">{review.date}</div>
            </div>
            <div className="text-xs text-muted-foreground">{review.platform}</div>
            <div className="text-xs text-foreground">★ {review.rating.toFixed(1)}</div>
            <p className="text-sm text-muted-foreground">{review.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
